<template>
  <div class="post-name" layout layout-align="start-center">
    <el-tooltip placement="top" :disabled="post.description === undefined">
      <div class="description-tooltip" slot="content">
        <span v-if="post.description">{{ post.description }}</span
        ><span v-else>自己紹介なし</span>
      </div>
      <icon
        class="mr-x1"
        :class="{ 'help-icon': post.description !== undefined, 'border-white': isWhite }"
        :name="post.name || post.screenName"
        :pictureUrl="pictureUrl"
      ></icon>
    </el-tooltip>
    <div layout="column" layout-align="space-between">
      <span class="name" :class="{ 'text-white': isWhite }">{{
        snsType === 'tiktok' ? post.screenName : post.name
      }}</span
      ><span layout="row" layout-align="start-center"
        ><a
          class="screen-name"
          v-if="snsType === 'twitter'"
          :class="{ 'text-white': isWhite }"
          :href="`https://x.com/${post.screenName}`"
          target="_new"
          >@{{ post.screenName }}</a
        ><a
          class="screen-name"
          v-else-if="snsType === 'instagram'"
          :class="{ 'text-white': isWhite }"
          :href="`https://instagram.com/${post.screenName}`"
          target="_new"
          >@{{ post.screenName }}</a
        ><a
          class="screen-name"
          v-else-if="snsType === 'tiktok'"
          :class="{ 'text-white': isWhite }"
          :href="`https://tiktok.com/@${post.screenName}`"
          target="_new"
          >@{{ post.screenName }}</a
        >
        <el-tooltip v-if="post.isFollowing" placement="top" content="フォロー中">
          <div class="mdi mdi-check-circle"></div>
        </el-tooltip>
        <el-tooltip v-if="post.isSuspendedAccount" placement="top" content="凍結中">
          <div class="mdi mdi-snowflake-alert"></div>
        </el-tooltip>
        <el-tooltip v-if="post.isNg" placement="top" content="NGアカウント">
          <div class="mdi mdi-cancel"></div> </el-tooltip
      ></span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.name {
  /* stylelint-disable value-no-vendor-prefix */
  display: -webkit-box;
  max-height: 18px; /* fallback */
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1; /* number of lines to show */
  line-height: 18px; /* fallback */
  /* stylelint-enable value-no-vendor-prefix */
  -webkit-box-orient: vertical;
}

.screen-name {
  font-size: $font-small-size;
  color: $sub-text-color;
}

.help-icon {
  &:hover {
    cursor: help;
  }
}

.mdi {
  width: $spacing-unit * 2;
  height: $spacing-unit * 2;
  margin: 0 0 0 2px;
  font-size: $font-large-size;
}

.mdi-check-circle {
  color: $success-color;
}

.mdi-alert {
  color: $warning-color;
}

.mdi-new-box {
  color: $danger-color;
}

.mdi-cancel {
  color: $danger-color;
}

.mdi-heart {
  color: $primary-color;
}

.mdi-snowflake-alert {
  color: $info-color;
}

.description-tooltip {
  max-width: $spacing-unit * 45;
  white-space: pre-wrap;
}

.border-white {
  border: 1px solid $text-color-white;
  border-radius: 50%;
}

.text-white {
  color: $text-color-white;
}
</style>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { defineComponent } from 'vue'

import Icon from '@/client/components/_atoms/basic_icon'

export default defineComponent({
  components: {
    Icon
  },
  props: {
    post: Object,
    snsType: {
      type: String,
      default: 'twitter'
    },
    isWhite: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    pictureUrl() {
      if (this.post.pictureUrl) {
        return this.post.pictureUrl
      }

      if (this.snsType === 'twitter') {
        return require('@/client/assets/images/twitter_default_profile.png')
      }

      if (this.snsType === 'instagram') {
        return require('@/client/assets/images/instagram_default_profile.png')
      }
    }
  }
})
</script>
